import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HelperService } from '../shared/services/helper.service';
import { environment } from 'src/environments/environment';
import { HttpService } from '../shared/services/http.service';

@Injectable()
export class FileService {
    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    public FILE_ORDER = 'ORDE';
    public FILE_COTIZ = 'COTI';
    public FILE_ADIC1 = 'ADI1';
    public FILE_ADIC2 = 'ADI2';
    public FILE_ADIC3 = 'ADI3';
    public FILE_LIQUI = 'LIKI';
    public FILE_CONST = 'CONS';
    public FILE_GUIAC = 'GUIA';

    constructor(private httpService: HttpService) { }

    public UploadFile(formData: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accepted-Encoding': 'form-data'
            })
        };
        this.URL = `${this.REQUEST_URL}/uploadFile`;
        return this.httpService.put<any>(this.URL, formData, httpOptions);
    }

    public DownloadFile(params) {
        this.URL = `${this.REQUEST_URL}/downloadFile`;
        return this.httpService.post<any[]>(this.URL, params);
    }

    public CreateGiftCardOrderSalesFile(formData: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accepted-Encoding': 'form-data'
            })
        };
        this.URL = `${this.REQUEST_URL}/createGiftCardOrderSalesFile`;
        return this.httpService.post<any>(this.URL, formData, httpOptions);
    }

    public CreateGiftCardOrderSalesFisicaFile(formData: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accepted-Encoding': 'form-data'
            })
        };
        this.URL = `${this.REQUEST_URL}/createGiftCardOrderSalesFisicaFile`;
        return this.httpService.post<any>(this.URL, formData, httpOptions);
    }

    public CreateGiftCardOrderSalesTiendaFile(formData: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accepted-Encoding': 'form-data'
            })
        };
        this.URL = `${this.REQUEST_URL}/createGiftCardOrderSalesTiendaFile`;
        return this.httpService.post<any>(this.URL, formData, httpOptions);
    }

    public UpdateOrderSalesStatusFile(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesStatusFile`;
        return this.httpService.put<any>(this.URL, params);
    }

}